import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormioCustomComponent} from "@formio/angular";
import {Subscription} from "rxjs";
import {CatalogDataModel} from "../../../../core/services/catalog-data/catalog-data.model";
import {CatalogDataService} from "../../../../core/services/catalog-data/catalog-data.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'sb-portal-buttons,sb-dynamic-portal-buttons',
  templateUrl: './portal-buttons.component.html',
  styleUrls: ['./portal-buttons.component.scss']
})
export class PortalButtonsComponent implements FormioCustomComponent<string>, OnInit, OnDestroy {

  @Input()
  disabled: boolean;

  @Input()
  value: string;

  @Output()
  valueChange: EventEmitter<string> = new EventEmitter<string>();

  catalogLoadedSubscription: Subscription | null;

  catalog: CatalogDataModel;

  highlightedItems: CatalogDataModel[] = [];

  constructor(private catalogDataService: CatalogDataService, private router: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.catalog = this.catalogDataService.getCatalog();
    if (this.catalog) {
      this.setButtonIds();
    } else {
      const that = this;
      this.catalogLoadedSubscription = this.catalogDataService.catalogLoaded.subscribe((_) => {
        that.catalog = that.catalogDataService.getCatalog();
        that.setButtonIds();
      });
    }
  }

  ngOnDestroy(): void {
    this.catalogLoadedSubscription && this.catalogLoadedSubscription.unsubscribe();
  }

  setButtonIds() {
    this.highlightedItems = this.catalogDataService.getHighlightedItems().filter((item) => item.order < 0);
  }

  gotoCatalogItem(id: string) {
    this.router.navigateByUrl(`Catalog/${id}`);
  }

  gotoCatalogHome() {
    window.top.location.href = `/#/Catalog/Home`;
  }


}
